import { EmptyState } from '@libs/components';
import { DataWithLoaderWrapper } from './styles';

type DataWithLoaderProps = {
  loading?: boolean;
  hasData?: boolean;
  loader?: JSX.Element;
  emptyStateTitle?: string;
  icon?: string;
  children?: JSX.Element;
};

const DataWithLoader: React.FC<DataWithLoaderProps> = ({
  loading,
  hasData,
  loader,
  emptyStateTitle,
  icon,
  children,
}) => {
  return (
    <DataWithLoaderWrapper>
      {hasData ? children : null}
      {!hasData && (
        <EmptyState title={emptyStateTitle} img={icon} loading={loading} />
      )}
      {loading && loader}
    </DataWithLoaderWrapper>
  );
};

export default DataWithLoader;
